import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";
import { z } from "zod";

export const IBoxListOfWarehousesMessagesScheme = z.object({
  list_of_warehouses_title:
    themeScheme.MessageScheme.default("Wybierz hurtownię"),
  list_of_warehouses_description: themeScheme.MessageScheme.default(
    "Znajdź najbliższą hurtownię, aby dowiedzieć się więcej o godzinach otwarcia i dostępności produktów."
  ),
  list_of_warehouses_search_input_placeholder:
    themeScheme.MessageScheme.default("Miejscowość lub kod pocztowy"),
  list_of_warehouses_use_map_text:
    themeScheme.MessageScheme.default("Wybierz z mapy"),
  list_of_warehouses_use_list_text:
    themeScheme.MessageScheme.default("Wybierz z listy"),
  list_of_warehouses_self_service_points_text:
    themeScheme.MessageScheme.default("Punkty z opcją samoobsługi"),
  list_of_warehouses_open_from_text:
    themeScheme.MessageScheme.default("Otwarte od 6:30"),
  list_of_warehouses_opening_hours_text:
    themeScheme.MessageScheme.default("Godziny otwarcia"),
  list_of_warehouses_warehouse_not_available: themeScheme.MessageScheme.default(
    "Oddział UNIMAX nie jest jeszcze dostępny online na Platformie, ale można odwiedzić go osobiście i dokonać zakupu na miejscu."
  ),
  list_of_warehouses_warehouse_without_products:
    themeScheme.MessageScheme.default(
      "Punkt obsługi klientów bez dostępnych produktów na miejscu"
    ),
  list_of_warehouses_subtitle: themeScheme.MessageScheme.default(
    "Znajdź najbliższą hurtownię, aby móc odbierać zamówienia i sprawdzać dostępność produktów."
  ),
  list_of_warehouses_choose_button_label:
    themeScheme.MessageScheme.default("Wybierz"),
  store_search_bar_search_input_placeholder_text:
    themeScheme.MessageScheme.default("Miejscowość lub kod pocztowy"),
  list_of_warehouses_street_shortcut: themeScheme.MessageScheme.default("ul."),
  list_of_warehouses_can_not_choose_warehouse_label:
    themeScheme.MessageScheme.default("Nie możesz wybrać tego punktu"),
});

export const IBoxListOfWarehousesSettingsScheme = z.object({
  list_of_warehouses_geolocalization_button_style:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  list_of_warehouses_title_text_style:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  list_of_warehouses_title_text_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_subtitle_text_style:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  list_of_warehouses_subtitle_text_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_search_placeholder_text_style:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  list_of_warehouses_search_placeholder_text_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_filter_text_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_warehouse_name_style:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  list_of_warehouses_warehouse_name_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_warehouse_address_style:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  list_of_warehouses_warehouse_address_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_disable_text_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_switch_text_style:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  list_of_warehouses_switch_text_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_switch_background_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_switch_border_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_switch_border_size: z.string().default("0").catch("0"),
  list_of_warehouses_switch_dot_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_change_view_button_style:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  list_of_warehouses_choose_button_style:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  store_search_bar_search_input_settings:
    themeScheme.InputIdScheme.default("input$$1").catch("input$$1"),
  store_search_bar_search_button_settings:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  list_of_warehouses_disabled_tooltip_label_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  list_of_warehouses_disabled_tooltip_mobile_title_style:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  list_of_warehouses_disabled_tooltip_desktop_subtitle_style:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
});
